import { observer } from "mobx-react-lite";
import React from "react";
import { ProductionManagement } from "./ProductionManagement";
import { TechnicalReport } from "./TechnicalReport";
export const GlobalLinkBaseView = observer(() => {
  return (
    <>
      <ProductionManagement />
      <TechnicalReport />
    </>
  );
});

